import AllSampleRequest from '@features/sampleDevelopment/components/AllSampleRequest';

const SampleRequestList = ({ requestFrom }) => {
	return <AllSampleRequest requestFrom={requestFrom} />;
};

export default SampleRequestList;
